<section class="w-full p-4">
    <div class="mt-5">
        <form [formGroup]="filterForm" (ngSubmit)="onApplyFilters()" class="space-y-6">
            <div class="flex flex-wrap items-end justify-start gap-4">
                <div>
                    <label for="search" class="block text-sm font-medium text-[#172C41] mb-1">Buscar</label>
                    <input 
                        id="search"
                        type="text"
                        formControlName="search"
                        placeholder="Buscar por nombre o ID"
                        [disabled]="isLoading()"
                        class="w-full rounded-[4px] border border-gray-300 px-3 py-2 text-sm focus:border-[#F99C1E] focus:ring-1 focus:ring-[#F99C1E] disabled:opacity-50"
                    />
                </div>

                <div>
                    <label for="groupId" class="block text-sm font-medium text-[#172C41] mb-1">Grupos</label>
                    <select
                        id="groupId"
                        formControlName="groupId"
                        [disabled]="isLoading()"
                        class="min-w-[200px] rounded-[4px] border border-gray-300 px-3 py-2 text-sm focus:border-[#F99C1E] focus:ring-1 focus:ring-[#F99C1E] disabled:opacity-50"
                    >
                        <option [ngValue]="null">Seleccionar grupo</option>
                        @for (group of groupOptions(); track group.value) {
                            <option [ngValue]="group.value">{{ group.label }}</option>
                        }
                    </select>
                </div>
                
                <div>
                    <label for="sortBy" class="block text-sm font-medium text-[#172C41] mb-1">Ordenar por</label>
                    <select
                        id="sortBy"
                        formControlName="sortBy"
                        [disabled]="isLoading()"
                        class="min-w-[200px] rounded-[4px] border border-gray-300 px-3 py-2 text-sm focus:border-[#F99C1E] focus:ring-1 focus:ring-[#F99C1E] disabled:opacity-50"
                    >
                        <option [ngValue]="null">Seleccionar orden</option>
                        @for (option of sortByOptions(); track option.value) {
                            <option [ngValue]="option.value">{{ option.label }}</option>
                        }
                    </select>
                </div>

                <div>
                    <label for="sortOrder" class="block text-sm font-medium text-[#172C41] mb-1">Orden</label>
                    <select
                        id="sortOrder"
                        formControlName="sortOrder"
                        [disabled]="isLoading()"
                        class="min-w-[200px] rounded-[4px] border border-gray-300 px-3 py-2 text-sm focus:border-[#F99C1E] focus:ring-1 focus:ring-[#F99C1E] disabled:opacity-50"
                    >
                        <option [ngValue]="null">Seleccionar orden</option>
                        @for (option of sortOrderOptions(); track option.value) {
                            <option [ngValue]="option.value">{{ option.label }}</option>
                        }
                    </select>
                </div>

                <div class="flex flex-wrap gap-4">
                    <button
                        type="button"
                        (click)="onClearFilters()"
                        class="inline-flex items-center gap-1 px-4 py-2 rounded-[4px] font-medium border border-[#172C41] text-[#172C41] cursor-pointer transition-colors text-sm hover:bg-gray-100"
                    >
                        <svg class="size-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
                        </svg>
                        Limpiar
                    </button>
                    <button
                        type="submit"
                        class="inline-flex items-center gap-1 px-4 py-2 rounded-[4px] font-medium bg-[#F99C1E] text-white cursor-pointer transition-colors text-sm hover:bg-[#e88c0e]"
                    >
                        <svg class="size-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
                        </svg>
                        Buscar
                    </button>
                </div>
            </div>
        </form>
    </div>
</section>
